import Vue from '@/index.js'

import page from '@/mixins/page'

import layoutCart from '@/components/layout/cart/layout-cart'

export default new Vue({
  el: '#app',
  components: {
    layoutCart
  },
  mixins: [page]
})
